import React from 'react';
import { Link, Routes, Route } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageMetadata from '../components/PageMetadata';

const ResourcesHome = () => (
  <div>
    <PageMetadata
      title="UPSC & KPSC Study Resources | Adhva Academy"
      description="Explore NCERT notes, current affairs, PYQs, MCQ practice and preparation strategies for UPSC and KPSC exams."
    />
    <div className="page-header">
      <div className="container">
        <h1 data-testid="page-title">Study Resources</h1>
        <p>Comprehensive study materials for UPSC preparation</p>
      </div>
    </div>

    <section className="py-8 container">
      <div className="grid grid-3">
        {[
          { icon: '📚', title: 'NCERT Notes', desc: 'Chapter-wise notes and summaries', link: '/resources/scert-notes' },
          { icon: '📰', title: 'Current Affairs', desc: 'Monthly updates and compilations', link: '/resources/current-affairs' },
          { icon: '📝', title: 'Previous Year Questions', desc: 'Solved PYQs with explanations', link: '/resources/pyqs' },
          { icon: '✍️', title: 'MCQs Practice', desc: 'Topic-wise practice questions', link: '/resources/mcqs' },
          { icon: '💡', title: 'Strategy & Tips', desc: 'Preparation strategies and tips', link: '/resources/strategy' }
        ].map((item, idx) => (
          <Link key={idx} to={item.link} className="card" style={{ textDecoration: 'none', color: 'inherit' }} data-testid={`resource-${idx}`}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem', textAlign: 'center' }}>{item.icon}</div>
            <h3 style={{ textAlign: 'center', marginBottom: '0.5rem' }}>{item.title}</h3>
            <p style={{ textAlign: 'center', color: 'var(--muted-foreground)' }}>{item.desc}</p>
          </Link>
        ))}
      </div>
    </section>

    <section className="py-8" style={{ background: 'var(--secondary)' }}>
      <div className="container text-center">
        <h2 style={{ marginBottom: '1.5rem' }}>Want Structured Guidance?</h2>
        <p style={{ color: 'var(--muted-foreground)', marginBottom: '2rem', fontSize: '1.125rem' }}>
          Join our comprehensive programs with personalized mentorship
        </p>
        <a 
          href="https://forms.gle/5mjmuxov7LaYCHTU6" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="btn-primary" 
          style={{ fontSize: '1.1rem', padding: '1rem 2.5rem' }}
        >
          Enroll Now →
        </a>
      </div>
    </section>
  </div>
);

const ComingSoon = ({ title }) => (
  <div>
    <PageMetadata
      title={`${title} | Study Resources | Adhva Academy`}
      description={`Explore ${title.toLowerCase()} resources and preparation support for UPSC, KPSC and competitive exams from Adhva Academy.`}
    />
    <div className="page-header">
      <div className="container">
        <h1>{title}</h1>
      </div>
    </div>
    <section className="py-8 container text-center">
      <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚀</div>
        <h2 style={{ marginBottom: '1rem' }}>Coming Soon</h2>
        <p style={{ color: 'var(--muted-foreground)', fontSize: '1.125rem' }}>We're working hard to bring you quality content. Stay tuned!</p>
        <Link to="/resources" className="btn-primary" style={{ marginTop: '2rem' }}>Back to Resources</Link>
      </div>
    </section>
  </div>
);

const ResourcesPage = () => {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<ResourcesHome />} />
        <Route path="/scert-notes" element={<ComingSoon title="NCERT Notes" />} />
        <Route path="/current-affairs" element={<ComingSoon title="Current Affairs" />} />
        <Route path="/pyqs" element={<ComingSoon title="Previous Year Questions" />} />
        <Route path="/mcqs" element={<ComingSoon title="MCQs Practice" />} />
        <Route path="/strategy" element={<ComingSoon title="Strategy & Tips" />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default ResourcesPage;
